import { PaymentMethod } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '..';
import * as Types from './types';

const { ActionTypes } = Types;

export const LoadPaymentProviders = (): Types.LoadPaymentProvidersAction => ({
    type: ActionTypes.LOAD_PROVIDER_LIST,
});

export const UpdateProviderList = (providers: PaymentMethod[]): Types.UpdateProviderListAction => ({
    type: ActionTypes.UPDATE_PROVIDER_LIST,
    payload: {
        providers,
    },
});

export const PaymentsError = (): Types.PaymentsErrorAction => ({
    type: ActionTypes.PAYMENTS_ERROR,
});

export const getProviders = (store: ApplicationState): Types.PaymentsState['providers'] => store?.payments?.providers;
